function isRequired(value, length=1) {
  return  value !== undefined && value !== null && value.length >= length
}

function isNumeric(value, allowZero=false, max=null, checkForBad=false) {
  if ( checkForBad && `${parseInt(value, 10)}` !== value ) {
    return false
  }
  if (allowZero && max === null) {
    return  value !== undefined && value !== null && parseInt(value, 10) >= 0
  } else if (max === null) {
    return  value !== undefined && value !== null && parseInt(value, 10) > 0
  } else if (allowZero) {
    return  value !== undefined && value !== null && parseInt(value, 10) >= 0 && parseInt(value, 10) <= max
  } else {
    return  value !== undefined && value !== null && parseInt(value, 10) > 0 && parseInt(value, 10) <= max
  }
}

function isUnsigned(val) {
  const value = parseFloat(val)
  return  value !== undefined && value !== null && parseInt(value, 10) === value
}

function validateEmailType(value) {
  return value && /^[a-zA-Z0-9\.\-_]+@[a-zA-Z0-9]\.?([A-Za-z0-9\-_]+\.)+([A-Za-z]+)$/i.test(value)
}

function validatePhoneType(value) {
  return /^\+?[0-9]{7,}$/i.test(value)
}


function validatePasswordLength(value) {
  return value !== undefined && value !== null && value.length > 6
}

function optionalPasswordLength(value) {
  return (value === undefined || value === null || value.length === 0 || value.length > 6)
}

export {
  isRequired,
  isNumeric,
  isUnsigned,
  validateEmailType,
  validatePhoneType,
  validatePasswordLength,
  optionalPasswordLength
}



// WEBPACK FOOTER //
// ./src/js/validators/index.js